import {Pipe, PipeTransform} from '@angular/core';
import {addTimeToArrayFromToken} from "ngx-bootstrap/chronos/parse/token";

@Pipe({
    name: 'filter1'
})
export class FilterPipe implements PipeTransform {

    transform(value, arg, ...type) {
        if (!arg) {
            return value;
        }

        let filteredTasks = [];
        arg.forEach(item => {
            if (item['tags'] !== []) {
                if (item['tags'].filter((val) => {
                    let j = val.includes(value);
                    if (j === true) {
                        if (arg.find(x => x.id === item['_id']) == undefined) {
                            filteredTasks.push(item);
                        }
                    }
                })) {

                }
            }
        });
        return filteredTasks;

    }


}
